import { useMemo } from "react";

import { CaseDetailState } from "shared/reducers/caseDetailReducer";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { useAppSelector } from "store/hooks";

import { DialogEnum } from "./Dialog";
import DialogButton from "./DialogButton";
import { canSignoutCase, isFinalized } from "./utils";

const DiagnosisDialogButton = ({
  caseDetailObject,
  dialog,
  setDialog,
}: {
  caseDetailObject: CaseDetailState;
  dialog: DialogEnum | null;
  setDialog: Function;
}) => {
  const currentUser = useAppSelector((state) => state.auth?.user);
  const canSignOutInViewer = useAppSelector((state) =>
    selectFeatureFlag(state, "signOutInViewer")
  );

  const canSignOutCase = canSignoutCase(
    caseDetailObject,
    currentUser,
    canSignOutInViewer
  );

  const showButton = useMemo(() => {
    if (
      caseDetailObject.specimens?.length &&
      !(caseDetailObject.is_screening && !caseDetailObject.finalize_assignment)
    ) {
      // If the case is finalized, a flat diagnosis is always shown
      if (isFinalized(caseDetailObject)) return true;

      // The user is allowed to signout the case will show either flat or input diagnoses
      if (canSignOutCase) return true;
    }

    return false;
  }, [caseDetailObject]);

  return showButton ? (
    <DialogButton
      currentDialog={dialog}
      wantedDialog={DialogEnum.InputDiagnosis}
      setDialog={setDialog}
      hotkey="d, shift+d"
      title="Diagnosis"
    >
      <u>D</u>iagnosis
    </DialogButton>
  ) : null;
};

export default DiagnosisDialogButton;
